import { DataInfoWithBadge } from "@/components/ui/data-info";
import { useValidation } from "./contexts/validationContext";

export default function OPMStatusValidation() {
  const { overallStatus } = useValidation();

  return <DataInfoWithBadge label="Checking Profile Status" value={overallStatus} />;
}
